import React from 'react';
import PropTypes from 'prop-types';

const PROMPT_TYPE_OPTIONS = [
  {
    value: 'System User',
    title: 'System + User Messages',
    description: 'Best for role-based prompts. System defines role, User provides input.',
  },
  {
    value: 'User Only',
    title: 'User Message Only',
    description: 'Best for simple, direct prompts. Single instruction without system context.',
  },
  {
    value: 'System  User  Assistant ',
    title: 'System + User + Few-Shot Examples',
    description: 'Best for learning from examples. Show format through demonstrations.',
  },
];

const StepPromptType = ({ formData, updateFormData }) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>Choose your prompt structure</h3>
        <p>Select how your prompt messages should be organized.</p>
      </div>

      <div className="radio-group">
        {PROMPT_TYPE_OPTIONS.map((option) => (
          <label 
            key={option.value} 
            className={`radio-card ${formData.prompt_type === option.value ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name="prompt_type"
              value={option.value}
              checked={formData.prompt_type === option.value}
              onChange={(e) => updateFormData('prompt_type', e.target.value)}
            />
            <div className="radio-content">
              <span className="radio-title">{option.title}</span>
              <span className="radio-description">{option.description}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

StepPromptType.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepPromptType;

